import { format } from 'date-fns';
import React, { FC, useState, useMemo } from 'react';
import {
  Image,
  TouchableOpacity,
  useWindowDimensions,
  View,
} from 'react-native';
import Swiper from 'react-native-web-swiper';
import { Button } from '../../../components/Button';
import { Text } from '../../../components/Text';
import { IS_WEB } from '../../../constants/platform';
import { STYLE_VARS } from '../../../constants/style-vars';
import { useIsDesktop } from '../../../hooks/useIsDeskTop';
import { RootState } from '../../../services/redux/store';
import { useSelector } from 'react-redux';
import { COLORS, FONTS } from '../../../constants';
import { NavigationService } from '../../../services/navigation';
import { IEvent } from '../../../types';
import dayjs from 'dayjs';

function extractSrcFromHtml(htmlString: string): string | null {
  const imgRegex = /<img.*?src=['"](.*?)['"]/i;
  const match = htmlString.match(imgRegex);
  const src = match ? match[1] : null;
  return src;
}

export const Events: FC = () => {
  const { width: screenWidth } = useWindowDimensions();
  const [mobileSwiperWrapper, setMobileSwiperWrapper] = useState(0);
  const isDesktop = useIsDesktop();
  const { events } = useSelector((state: RootState) => state?.eventReducer);

  if (isDesktop()) {
    return (
      <View style={{ marginTop: 40 }}>
        <Text
          style={{
            fontFamily: FONTS.IowanOldStyleBTRoman,
            color: STYLE_VARS.primaryColor,
            fontSize: 22,
          }}
        >
          UPCOMING EVENTS
        </Text>

        <View
          style={{
            height: 2,
            width: '100%',
            backgroundColor: '#0000000d',
            marginBottom: 40,
            marginTop: 20,
          }}
        />

        {events && events?.map((event: IEvent) => {
          return (
            <>
              <View
                key={event.id}
                style={{
                  flexDirection: 'row',
                  paddingLeft: 40,
                  position: 'relative',
                }}
              >
                {event.thumb && (
                  <Image
                    source={IS_WEB ? { uri: event.thumb } : { uri: event.thumb }}
                    style={{ width: 260, height: 130 }}
                  />
                )}

                <View style={{ flex: 1, paddingHorizontal: 20 }}>
                  <Text
                    style={{
                      fontSize: 15,
                      fontWeight: '600',
                      color: STYLE_VARS.primaryColor,
                      marginBottom: 6,
                    }}
                    numberOfLines={2}
                  >
                    {event?.title.toUpperCase()}
                  </Text>
                  <Text
                    style={{
                      fontFamily: FONTS.AvenirMedium,
                      fontSize: 13,
                      fontWeight: '500',
                      color: COLORS.DARKER_GREY,
                      textTransform: 'uppercase',
                    }}
                    numberOfLines={2}
                  >
                    {dayjs(new Date(event.start * 1000)).format('DD-MM-YYYY')}
                    <Text style={{paddingHorizontal: 5}}>-</Text>
                    {dayjs(new Date(event.end * 1000)).format('DD-MM-YYYY')}
                    {/*{event.startDate &&*/}
                    {/*  format(event.startDate, 'EEE do MMM').toUpperCase()}*/}
                    {/*{' - '}*/}
                    {/*{event.endDate &&*/}
                    {/*  format(event.endDate, 'EEE do MMM').toUpperCase()}*/}
                  </Text>
                </View>

                <View
                  style={{
                    flexDirection: 'row',
                    gap: 20,
                    alignItems: 'center',
                    alignSelf: 'flex-start',
                  }}
                >
                  <Button
                    text="READ MORE"
                    style={STYLE_VARS.blueButton}
                    onPress={() => {
                      NavigationService.push<'Root'>('Root', {
                        screen: 'MenuTab',
                        params: {
                          screen: 'EventDetail',
                          params: {
                            id: event?.id,
                          },
                        },
                      });
                    }}
                  />
                </View>

                <View
                  style={{
                    backgroundColor: '#d2232a',
                    padding: 10,
                    position: 'absolute',
                    borderRadius: 30,
                    alignItems: 'center',
                    justifyContent: 'center',
                    aspectRatio: 1,
                    top: -20,
                    left: 20,
                  }}
                >
                  <Text
                    style={{
                      fontSize: 12,
                      color: 'white',
                      fontFamily: FONTS.IowanOldStyleBTRoman,
                    }}
                  >
                    {/*{format(event.redDate, 'MMM').toUpperCase()}*/}
                  </Text>
                  <View style={{ flexDirection: 'row' }}>
                    <Text
                      style={{
                        fontSize: 18,
                        color: 'white',
                        fontFamily: FONTS.IowanOldStyleBTRoman,
                      }}
                    >
                      {/*{format(event.redDate, 'd').toUpperCase()}*/}
                    </Text>
                    <Text
                      style={{
                        fontSize: 12,
                        color: 'white',
                        fontFamily: FONTS.IowanOldStyleBTRoman,
                        maxWidth: '40px',
                        textAlign: 'center',
                      }}
                    >
                      {dayjs(new Date(event.start * 1000)).format('MMM DD').toUpperCase()}
                      {/* {format(
                        new Date(event.start).getTime(),
                        'EEE do MMM'
                      ).toUpperCase()} */}
                    </Text>
                  </View>
                </View>
              </View>

              <View
                style={{
                  height: 2,
                  width: '100%',
                  backgroundColor: '#0000000d',
                  marginVertical: 40,
                }}
              />
            </>
          );
        })}
        <View style={{ alignItems: 'center' }}>
          <Button
            text="BROWSE ALL EVENTS"
            style={[
              {
                paddingVertical: 12,
                paddingHorizontal: 24,
                alignSelf: 'center',
              },
            ]}
            onPress={() => {
              NavigationService.push<'Root'>('Root', {
                screen: 'MenuTab',
                params: {
                  screen: 'EventList',
                  params: {
                    screen: 'Grid',
                  },
                },
              });
            }}
          />
        </View>
      </View>
    );
  }

  return (
    <View style={{ marginTop: 60 }}>
      <Text
        style={{
          fontFamily: FONTS.IowanOldStyleBTRoman,
          color: STYLE_VARS.primaryColor,
          fontSize: 22,
          textAlign: 'center',
        }}
      >
        UPCOMING EVENTS
      </Text>

      <View style={{ height: mobileSwiperWrapper + 30 }}>
        {events.length > 0 ? (
          <Swiper
            key={mobileSwiperWrapper}
            controlsProps={{
              prevPos: false,
              nextPos: false,
              dotActiveStyle: { backgroundColor: STYLE_VARS.primaryColor },
              dotsTouchable: true,
            }}
          >
            {events && events?.map((event: IEvent) => {
              return (
                <View
                  key={event.id}
                  onLayout={({ nativeEvent }) =>
                    mobileSwiperWrapper < nativeEvent.layout.height &&
                    setMobileSwiperWrapper(nativeEvent.layout.height)
                  }
                >
                  <View style={{ position: 'relative', marginTop: 30 }}>
                    {event.thumb && (
                      <Image
                        source={IS_WEB ? { uri: event.thumb } : { uri: event.thumb }}
                        style={{
                          width: screenWidth - 40,
                          height: (screenWidth - 40) * (3 / 4),
                        }}
                      />
                    )}

                    <View
                      style={{
                        backgroundColor: 'red',
                        padding: 10,
                        position: 'absolute',
                        borderRadius: 30,
                        alignItems: 'center',
                        justifyContent: 'center',
                        aspectRatio: 1,
                        top: -30,
                        left: 0,
                      }}
                    >
                      {/*<Text style={{ fontSize: 15, color: 'white' }}>*/}
                      {/*  {format(event.redDate, 'MMM').toUpperCase()}*/}
                      {/*</Text>*/}
                      <View style={{ flexDirection: 'row' }}>
                        <Text style={{ fontSize: 18, color: 'white' }}>
                          {dayjs(new Date(event.start * 1000)).format('MMM DD').toUpperCase()}
                        </Text>
                        {/* <Text style={{ fontSize: 12, color: 'white' }}>TH</Text> */}
                      </View>
                    </View>

                    <Text
                      style={{
                        fontSize: 18,
                        fontWeight: '600',
                        color: STYLE_VARS.primaryColor,
                        marginVertical: 24,
                        textAlign: 'center',
                      }}
                      numberOfLines={1}
                    >
                      {event.title.toUpperCase()}
                    </Text>

                    <Text
                      style={{
                        fontSize: 15,
                        textAlign: 'center',
                      }}
                      numberOfLines={1}
                    >
                      {event.start &&
                        // format(event.created_at, 'EEE do MMM').toUpperCase()
                        dayjs(new Date(event.start * 1000)).format('MMM DD').toUpperCase()}
                      {' - '}
                      {/*{event.endDate &&*/}
                      {/*  format(event.endDate, 'EEE do MMM').toUpperCase()}*/}
                    </Text>

                    <Button
                      text="READ MORE"
                      style={{
                        paddingVertical: 12,
                        width: '45%',
                        alignSelf: 'center',
                        marginVertical: 30,
                      }}
                    />
                  </View>
                </View>
              );
            })}
          </Swiper>
        ) : (
          <></>
        )}
      </View>
    </View>
  );
};
